import gql from 'graphql-tag';

const RELOCK_TOKEN = gql`
    mutation relockToken(
        $subscriptionId: String!
    ) {
        relockToken(
            relockTokenInput: {
                subscriptionId: $subscriptionId
            }
        )
            {
                id
                userId
                walletAddress
                duration
                totalToken
                status
                tickets
                networkId
            }
    }
`;

export default RELOCK_TOKEN;